import { render, staticRenderFns } from "./cgit.vue?vue&type=template&id=85e2b780&scoped=true&"
import script from "./cgit.vue?vue&type=script&lang=js&"
export * from "./cgit.vue?vue&type=script&lang=js&"
import style0 from "./cgit.vue?vue&type=style&index=0&id=85e2b780&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e2b780",
  null
  
)

export default component.exports